import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { type DataProviderSet, DataType, type TableData } from '../types';
import { tableToBreakdownSingleDataSet } from './table-to-breakdown-single-data-set';
import { tableToSingleDataSet } from './table-to-single-data-set';
import { tableToTimeseriesDataSet } from './table-to-timeseries-data-set';

const CONVERTERS = {
  [DataType.SINGLE]: tableToSingleDataSet,
  [DataType.TIMESERIES]: tableToTimeseriesDataSet,
  [DataType.BREAKDOWN_SINGLE]: tableToBreakdownSingleDataSet,
} satisfies Partial<
  Record<
    DataType,
    (table: TableData, metric?: MetricValues) => DataProviderSet | undefined
  >
>;

export type TableDataSetType = keyof typeof CONVERTERS;

export const isTableDataSetType = (
  dataType: DataType
): dataType is TableDataSetType => dataType in CONVERTERS;

export const tableToDataSet = (
  table: TableData,
  dataType: TableDataSetType,
  metric?: MetricValues
): DataProviderSet | undefined => CONVERTERS[dataType](table, metric);
